import firebase from 'firebase'
import firestore from 'firebase/firestore'

// Your web app's Firebase configuration
var firebaseConfig = {
apiKey: "AIzaSyCEun3jbt1pPO4W5qpDeWLXTGJfEYOiaU0",
authDomain: "hydrovacking-3ddf5.firebaseapp.com",
databaseURL: "https://hydrovacking-3ddf5.firebaseio.com",
projectId: "hydrovacking-3ddf5",
storageBucket: "hydrovacking-3ddf5.appspot.com",
messagingSenderId: "114658757089",
appId: "1:114658757089:web:77dc58991c65014f"
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

export default firebase.firestore()
